var state = {
  status: 0,
  points: [],
  index: 0
};
var mutations = {
  CHANGE_PLAY_INDEX: function CHANGE_PLAY_INDEX(state, i) {
    state.index = i;
  },
  CHANGE_ALL_POINTES: function CHANGE_ALL_POINTES(state, p) {
    state.points = p;
  },
  CHANGE_PLAY_STATUS: function CHANGE_PLAY_STATUS(state, s) {
    state.status = s;
  }
};
var actions = {
  change_play_index: function change_play_index(_ref, i) {
    var commit = _ref.commit;
    commit('CHANGE_PLAY_INDEX', i);
  },
  change_all_points: function change_all_points(_ref2, p) {
    var commit = _ref2.commit;
    commit('CHANGE_ALL_POINTES', p);
  },
  change_play_status: function change_play_status(_ref3, s) {
    var commit = _ref3.commit;
    commit('CHANGE_PLAY_STATUS', s);
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};